module.exports = __webpack_public_path__ + "static/media/6.7b38cc59.JPG";